module.exports = __webpack_public_path__ + "static/kitchen-2f370ed4a49c003ecf029ffe4046b554.jpg";